import { PushNotificationsStatus } from './types';

export const PUSH_NOTIFICATIONS_DEFAULT_STATUS: PushNotificationsStatus = PushNotificationsStatus.Unknown;
